import * as Cesium from 'cesium';
import styled from 'styled-components';
import ApiInterface from 'utils/ApiInterface';
import UpgradeModal from "components/UpgradeModal";
import ToolbarContainer from '../ToolbarContainer';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DataPrintModal from "components/DataPrintModal";
import DataExportModal from "components/DataExportModal";
import useViewerStore from '../../../store-zustand/viewer';
import DataDownloadModal from "components/DataDownloadModal";
import TooltipIconButton from 'components/TooltipIconButton';
import useProjectStore from '../../../store-zustand/project';
import DataMeasurementModal from "components/DataMeasurementModal";
import { DrawPolygon, DrawPin, ClearGlobalVariables, EditPolygonVertices, generateNodeImage } from '../../MapView/MapUtils';
import { Compare, PlaceOutlined, Straighten, ScreenshotMonitorOutlined, BrowserUpdatedOutlined } from '@mui/icons-material';

const Wrapper = styled(ToolbarContainer)`
  padding: 3px;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    z-index: 1;
    position: fixed;
    justify-content: flex-end;
    .hide-mobile {
      display: none;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`;

const MapToolbar = (props) => {
  const dispatch = useDispatch();

  const showModal = useSelector(state => state.settings.showExportModal);
  const showPrintModal = useSelector(state => state.settings.showPrintModal);
  const showMeasurementModal = useSelector(state => state.settings.showMeasurementModal);
  const showDataDownloadModal = useSelector(state => state.settings.showDataDownloadModal);
  const compareTool = useSelector(state => state.settings.compareTool);
  const MeasurementEnable = useSelector(state => state.settings.MeasurementEnable);
  const PinEnable = useSelector(state => state.settings.PinEnable);
  const { viewer, setmapboxvisibility } = useViewerStore();
  const [currentMeasurementValue, setcurrentMeasurementValue] = useState('0');
  const [currentMeasurementUnit, setCurrentMeasurementUnit] = useState('');
  const [currentMeasurementType, setCurrentMeasurementType] = useState('');
  const [display_measurementCondition, setdisplay_measurementCondition] = useState(true);
  const [currentLonLat, setcurrentLonLat] = useState('--');
  const { setcurrentAnnotationName, setcurrentAnnotationDescription, currentAnnotationIcon, currentAnnotationColor, currentAnnotationAlpha, currentPinSize, currentAnnotationWidth } = useProjectStore();
  const maxLevel = useSelector(state => state.settings.maxLevel);
  const MaptoolOption = useSelector(state => state.settings.showMapTool);
  const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false);

  const handleExportModal = () => {
    dispatch({ type: 'TOGGLE_EXPORT_MODAL', show: true });
    dispatch({ type: "TOGGLE_COMPARE_TOOL", compareTool: false });
  };

  const handlePrintModal = () => {
    isUserFreemium().then(userFremium => {
      if (userFremium){
        setUpgradeModalIsOpen(true);
        return;
      }

      dispatch({ type: 'TOGGLE_PRINT_MODAL', show: true });
      dispatch({ type: "TOGGLE_COMPARE_TOOL", compareTool: false });
    });
  };

  const handleMeasureOption = () => {
    if (MeasurementEnable == true) {
      let clear_annotation = false;
      ClearGlobalVariables(viewer, clear_annotation);
      setcurrentLonLat('--');
      setcurrentMeasurementValue(0);
      setdisplay_measurementCondition(true);
      dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: true });
      DrawPolygon(viewer, 'CurrentMeasureShape', true, true, '#487BF2', 1, 4, dispatch, setcurrentMeasurementValue, setcurrentLonLat);
      setmapboxvisibility(1);
    }

    setcurrentAnnotationName('');
    setcurrentAnnotationDescription('');

    dispatch({
      "type": "SET_SELECTED_EDITING_ANNOTATION", editingAnnotation: {
        type: 'Line'
      }
    })
    dispatch({ type: 'SET_PROJECT_PANEL', panel: 'EditAnnotation' });

  }

  useEffect(() => {
    setCurrentMeasurementUnit('m');
    setCurrentMeasurementType('Point');
  }, [window['CurrentPointCentroid']])

  const handleAddPin = () => {
    if (PinEnable == true) {
      let clear_annotation = false;
      ClearGlobalVariables(viewer, clear_annotation);
      setcurrentLonLat('--');
      setcurrentMeasurementValue(0);
      setdisplay_measurementCondition(true);
      DrawPin(viewer, 'defaultMarker.svg', "#487BF2", 50, setcurrentMeasurementValue, setcurrentLonLat);
      window['finishdrawing'] = true;
      dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: true });
      setmapboxvisibility(1);
    }
    
    setcurrentAnnotationName('');
    setcurrentAnnotationDescription('');
    dispatch({
      "type": "SET_SELECTED_EDITING_ANNOTATION", editingAnnotation: {
        type: 'Marker'
      }
    })
    dispatch({ type: 'SET_PROJECT_PANEL', panel: 'EditAnnotation' });
  }

  useEffect(() => {
    if (window.handlerDrawPointGeom) {
      window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      DrawPin(viewer, currentAnnotationIcon || 'defaultMarker.svg', currentAnnotationColor || "#487BF2", currentPinSize || 50, setcurrentMeasurementValue, setcurrentLonLat);
    }

    if (window.handlerEditPolygonGeom) {
      if (!window['finishdrawing']) {
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        DrawPolygon(viewer, 'CurrentMeasureShape', true, true, currentAnnotationColor, currentAnnotationAlpha, currentAnnotationWidth, dispatch, setcurrentMeasurementValue, setcurrentLonLat);
      } else {
        if (currentAnnotationColor) {
          window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
          window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
          window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
          window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
          window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
          window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
          window.taskingFeaturesArray.map(obj => {
            if (obj.billboard) {
              obj.billboard.image = generateNodeImage(currentAnnotationColor, true);
            }
          })
          
          EditPolygonVertices(viewer, 'CurrentMeasureShape', currentAnnotationColor)
        }
      }
    }
  }, [currentAnnotationIcon, currentAnnotationColor, currentAnnotationAlpha, currentPinSize, currentAnnotationWidth])

  useEffect(() => {
    if (window['CurrentPolygonArea'] == 0) {
      setCurrentMeasurementUnit('m');
      setCurrentMeasurementType('Line');
    } else {
      setCurrentMeasurementUnit('m²');
      setCurrentMeasurementType('Area');
    }

  }, [window['CurrentDistanceLeftMouse'], window['CurrentPolygonArea']]);

  const isUserFreemium = async () => {
    const userProfile = await ApiInterface.instance.userProfile().catch((error) => null)
    if (userProfile === null || 
        userProfile !== null && (userProfile.data.metadata?.plan === undefined || userProfile.data.metadata?.plan?.toLowerCase() === 'freemium')){
      return true;
    }
    
    return false;
  }

  const handleCompare = () => {
    isUserFreemium().then(userFremium => {
      if (userFremium){
        setUpgradeModalIsOpen(true);
        return;
      }

      dispatch({ type: "TOGGLE_COMPARE_TOOL", compareTool: !compareTool })
    });
  }

  return (
    <>
    {upgradeModalIsOpen && <UpgradeModal setIsOpen={setUpgradeModalIsOpen} templateName={'starter'} callOnClose={() => null}/>}
    <Wrapper data-tour="step-8">
      { MaptoolOption &&
        <>
          <TooltipIconButton title="Measure" ariaLabel="measure" placement="top" onClick={() => { handleMeasureOption(); }} size={50}>
            <Straighten className="iconStraighten" />
          </TooltipIconButton>
          <TooltipIconButton title="Map Pin" ariaLabel="map-pin" placement="top" onClick={() => { handleAddPin(); }} size={50}>
            <PlaceOutlined />
          </TooltipIconButton>
        </>
      }
      { MaptoolOption && props.missionDates && props.missionDates.length > 0 && maxLevel >= 10 ?
          <>
            <TooltipIconButton title="Compare" ariaLabel="compare" placement="top" size={50} onClick={handleCompare}>
              <Compare />
            </TooltipIconButton>
          </>
          : null
      }
      {props.missionDates && props.missionDates.length > 0 ?
        <>
          <TooltipIconButton title="Crop" ariaLabel="crop" placement="top" onClick={handleExportModal} size={50}>
            <BrowserUpdatedOutlined />
          </TooltipIconButton>
          <TooltipIconButton title="Print" ariaLabel="print" placement="top" onClick={handlePrintModal} size={50}>
            <ScreenshotMonitorOutlined />
          </TooltipIconButton>
        </>
        : null
      }
      {
        showModal && <DataExportModal missionDates={props.missionDates}/>
      }
      {
        showPrintModal && <DataPrintModal />
      }
      {showMeasurementModal && <DataMeasurementModal display_measurement={display_measurementCondition} measurementValue={currentMeasurementValue} measurementUnit={currentMeasurementUnit} geomType={currentMeasurementType} LonLat={currentLonLat} />}
      {showDataDownloadModal && <DataDownloadModal display_measurement={display_measurementCondition} measurementValue={currentMeasurementValue} measurementUnit={currentMeasurementUnit} geomType={currentMeasurementType} LonLat={currentLonLat} />}
    </Wrapper >
    </>
  );
};

export default MapToolbar;